export const FIRST_NAME = 'Kiran';
export const LAST_NAME = 'Bhattarai';
